import React from "react";
import { Box } from "../../design-system";
import { colors } from "../../design-system/colors";

interface DropdownMenuItemProps {
  icon: React.ReactNode;
  label: string;
  onClick: () => void;
}

const DropdownMenuItem = ({ icon, label, onClick }: DropdownMenuItemProps) => (
  <Box
    component="button"
    role="menuitem"
    onClick={onClick}
    sx={{
      display: "flex",
      alignItems: "center",
      gap: "8px",
      padding: "10px 4px",
      backgroundColor: "transparent",
      border: "none",
      cursor: "pointer",
      borderRadius: "100px",
      width: "100%",
      textAlign: "left",
      "&:hover": {
        backgroundColor: colors.background.buttonClose,
      },
      "&:focus-visible": {
        outline: `2px solid ${colors.primary[500]}`,
        outlineOffset: "2px",
      },
    }}
  >
    <Box sx={{ flexShrink: 0, display: "flex", alignItems: "center" }}>
      {icon}
    </Box>
    <Box
      sx={{
        color: colors.neutral.white,
        fontFamily: "Outfit, sans-serif",
        fontSize: "14px",
        fontWeight: 400,
        lineHeight: "16px",
        whiteSpace: "nowrap",
      }}
    >
      {label}
    </Box>
  </Box>
);

export default DropdownMenuItem;
